// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Cr","link":"e_Dr","imageContainer":"e_Er","author":"e_Fr","text":"e_Gr","buttonIcon":"e_Hr"};